import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Datagrid, Icon, Button } from "@abb/abb-common-ux-react";
import "./group-realtime-power.css";
import { BASE_URL } from '../../../strings';
import { getToken } from '../../Authentication/get-token';
import "./group-realtime-power.css"
const GroupRealtimePower = () => {
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [sortOrder, setSortOrder] = useState(undefined);
    const [columnOrder, setColumnOrder] = useState(undefined);
    const [columnFilters, setColumnFilters] = useState({});
    const [activeRow, setActiveRow] = useState(undefined);
    const [hideColumnFilters, setHideColumnFilters] = useState(false);

    const MemoizedActionComp = React.memo(({ i }) => (
        <>
            <Icon name="abb/alarm_bell" style={{ marginRight: '16px' }} onClick={() => alert(`Clicked icon on row ${i}`)} />
            <Button sizeClass="small" text={`Button ${i}`} onClick={() => alert(`Clicked button on row ${i}`)} />
        </>
    ));

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${BASE_URL}emapi/group_real_time_power`,getToken());
                const result = response.data.data || [];
                const rows = result.map((item, i) => ({
                    rowId: `row-${i}`,
                    fields: {
                        group: item.group,
                        p: item.p,
                        q: item.q,
                        s: item.s,
                        CustomContent: <MemoizedActionComp key={`row-${i}`} i={i} />,
                    },
                    expansionContent: (
                        <div
                            style={{
                                minHeight: '40px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                border: '1px dashed silver',
                                padding: '24px',
                            }}
                        >
                            <p style={{ marginBottom: '20px', fontSize: '18px' }}>Are you sure to delete?</p>
                            <div>
                                <p><span style={{ display: 'inline-block', width: '100px' }}>Group:</span> <span>{item.group}</span></p>
                                <p><span style={{ display: 'inline-block', width: '100px' }}>Power P:</span> <span>{item.p}</span></p>
                            </div>
                            <Button text="Delete" style={{ marginTop: '20px' }} data={i} onClick={(e, data) => deleteRow(e, data)} />
                        </div>
                    ),
                    isSelected: i % 4 === 0 ? null : false,
                    disableSelect: i % 5 === 0,
                    rowStatus: i % 7,
                    fieldStatuses: { p: i % 7 },
                }));

                setData(rows);
                setColumns([
                    { fieldKey: 'group', title: 'Group' },
                    { fieldKey: 'p', title: 'Active Power (P)' },
                    { fieldKey: 'q', title: 'Reactive Power (Q)' },
                    { fieldKey: 's', title: 'Apparent Power (S)' },
                ]);
            } catch (error) {
                console.error('Error fetching group realtime power:', error);
            }
        };

        fetchData();
    }, []);

    const deleteRow = (e, rowIndex) => {
        setData(data.filter((_, i) => i !== rowIndex).map((d) => ({ ...d, isExpanded: false })));
    };

    return (
        <Datagrid
            id='group-realtime-power'
            style={{ height: '300px', width: "100%" }}
            monochrome={true}
            data={data}
            columns={columns}
            page={currentPage}
            rowHeight="small"
            zebraColoring={4}
            enableSorting={true}
            enableRowExpansion={true}
            enableRowActivation={true}
            enableColumnDragging={true}
            enableColumnResize={true}
            onToggleRowSelect={(i) => {
                setData(data.map((d, index) => index === i ? { ...d, isSelected: !d.isSelected } : d));
            }}
            onToggleSelectAll={(oldValue, begin, end) => {
                setData(data.map((d, i) =>
                    i >= begin && i <= end && !d.disableSelect ? { ...d, isSelected: oldValue !== 2 } : d
                ));
            }}
            onActivateRow={(i, rowId) => {
                setData(data.map((d) => ({ ...d, isActive: d.rowId === rowId })));
                setActiveRow(data.find((r) => r.rowId === rowId));
            }}
            onToggleRowExpansion={(expandedRows, expandedRowIds) => {
                setData(data.map((d, i) => ({ ...d, isExpanded: expandedRows[i] === true })));
            }}
            sortOrder={sortOrder}
            onSort={(so) => setSortOrder(so)}
            columnOrder={columnOrder}
            onColumnOrderChange={(order) => setColumnOrder(order)}
            onColumnWidthsChange={(newWidths) => {
                setColumns(columns.map((c) => ({ ...c, width: newWidths[c.fieldKey] })));
            }}
            onClickColumnFiltersIcon={() => setHideColumnFilters(!hideColumnFilters)}
            onClickClearColumnFilters={() => {
                const newFilters = { ...columnFilters };
                Object.keys(newFilters).forEach((k) => newFilters[k].value = '');
                setColumnFilters(newFilters);
                setHideColumnFilters(true);
            }}
            customMessage={data.length !== 0 ? undefined : 'Nothing in data'}
        />
    );
};

export default GroupRealtimePower;
